module.exports = __webpack_public_path__ + "static/img/c38.edc298b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c38.jpg
// module id = 235
// module chunks = 0 1 2 3 4 5 6 7 8 9